import { KalturaAssetType } from '../../enums';
import { requestPhoenix } from '../../network';
import { KalturaOnDemandResponseProfile, KalturaPlaybackContext } from '../../objects';
import { KalturaPlaybackContextOptions } from '../../objects/KalturaPlaybackContextOptions';

export type FetchAssetPlaybackContextArgs = {
  assetId: string;
  assetType: KalturaAssetType;
  contextDataParams: KalturaPlaybackContextOptions;
  responseProfile?: KalturaOnDemandResponseProfile;
  sourceType?: string;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/asset/action/getPlaybackContext
 */
export async function fetchAssetPlaybackContext({
  assetId,
  assetType,
  contextDataParams,
  responseProfile,
  sourceType,
}: FetchAssetPlaybackContextArgs) {
  return requestPhoenix<KalturaPlaybackContext>({
    path: '/asset/action/getPlaybackContext',
    body: {
      assetId,
      assetType,
      contextDataParams,
      responseProfile,
      sourceType,
    },
  });
}
